// extracted by mini-css-extract-plugin
module.exports = {"star":"star__2YcBk","big":"big__2EFpx","label":"label__1iNz4","labelBig":"labelBig__3Z4hx","container":"container__3-ykG"};